export default (ua) => {
    const device = ua.device != 'Other' ? `${ua.device}, ` : ''
    const os = ua.os.family != 'Other' ? `${ua.os.family} ${ua.os.major} - ` : '';
    const browser = `${ua.browser.family} ${ua.browser.major}`
    return `${device}${os}${browser}`
}